/** Traductions rapport Achat vs Vente (FR / AR) */
export const achatVsVenteReportFr = {
  unavailableTitle: 'Rapport non disponible encore',
  unavailableDesc: 'Des ventes doivent être effectuées d\'abord avant de pouvoir afficher le rapport Achat vs Vente. Ce rapport analyse les bénéfices et coûts basés sur les données réelles de vente.',
  stepsTitle: 'Étapes requises :',
  step1: 'Ajouter des produits à l\'inventaire',
  step2: 'Acheter les produits (ajouter au stock)',
  step3: 'Effectuer des ventes',
  step4: 'Afficher le rapport Achat vs Vente',
  title: 'Rapport Achat vs Vente',
  subtitle: 'Analyse complète des bénéfices et coûts',
  subtitleBasis: 'Périodes calendaires fixes — calcul via agrégation journalière',
  computing: 'Calcul en cours…',
  periodToday: 'Aujourd\'hui',
  periodWeek: 'Cette Semaine',
  periodMonth: 'Ce Mois',
  periodYear: 'Cette Année',
  period28Days: '28 jours',
  period3Months: '3 mois',
  periodCurrentMonth: 'Mois en cours',
  period3CalendarMonths: '3 mois calendaires',
  basisLabel: 'Base de calcul :',
  basis28And3: '28 jours · 3 mois',
  basisCalendar: 'Mois en cours · 3 mois calendaires',
  linkStockReport: 'Voir mouvement de stock',
  comparisonTitle: 'Synthèse comparative',
  comparisonDesc: 'Indicateurs agrégés pour les deux périodes calendaires (bornes fixes)',
  colMetric: 'Indicateur',
  allCategories: 'Toutes les catégories',
  allMargins: 'Toutes les marges',
  marginHigh: 'Marge élevée (≥20%)',
  marginLow: 'Marge faible (<20%)',
  marginNegative: 'Marge négative',
  allPerformance: 'Toutes les performances',
  performanceHigh: 'Performance élevée',
  performanceNormal: 'Performance normale',
  performanceAttention: 'Besoin d\'attention',
  sortByProfit: 'Trier par profit',
  sortByRevenue: 'Trier par revenus',
  sortByMargin: 'Trier par marge',
  sortByName: 'Trier par nom',
  sortDesc: 'Ordre décroissant',
  sortAsc: 'Ordre croissant',
  hideCharts: 'Masquer graphiques',
  showCharts: 'Afficher graphiques',
  lastUpdate: 'Dernière mise à jour :',
  totalProductsLabel: 'Total produits :',
  periodLabel: 'Période :',
  kpiTotalRevenue: 'Revenus Totaux',
  kpiTotalRevenueDesc: 'De toutes les ventes',
  kpiTotalProfit: 'Bénéfice Total',
  kpiTotalProfitDesc: 'Bénéfice net',
  kpiAverageMargin: 'Marge Moyenne',
  kpiAverageMarginDesc: 'Taux de profit',
  kpiRealProfit: 'Bénéfice Réel',
  kpiRealProfitDesc: 'Après pertes d\'expiration',
  kpiExpiredLoss: 'Pertes d\'Expiration',
  expiredProductsUnit: 'produits expirés',
  kpiHighPerformers: 'Produits Performants',
  kpiHighPerformersDesc: 'Besoin d\'attention',
  kpiBestProduct: 'Meilleur Produit',
  kpiProfitMargin: 'Marge de Profit Total',
  kpiProfitMarginDesc: 'Ratio profit/revenus',
  chartRevenueVsCost: 'Revenus vs Coûts',
  chartRevenue: 'Revenus',
  chartCost: 'Coût',
  chartProfitDistribution: 'Distribution des Bénéfices',
  chartPerformanceOverview: 'Aperçu des Performances',
  chartHighPerformers: 'Produits Performants',
  chartNeedsAttention: 'Besoin d\'Attention',
  chartTotalProducts: 'Total Produits',
  tableTitle: 'Détail par produit',
  tableDesc: 'Comparaison des revenus, coûts et bénéfices',
  tableDescPeriod: 'Lignes filtrées pour la période : {{period}}',
  detailMeta: '{{count}} produit(s) — {{period}}',
  colProduct: 'PRODUIT',
  colItemsSold: 'ARTICLES VENDUS',
  colRevenue: 'REVENU',
  colCost: 'COÛT',
  colGrossProfit: 'BÉNÉFICE BRUT',
  colMargin: 'MARGE %',
  colExpiredProducts: 'PRODUITS EXPIRÉS',
  colExpirationLoss: 'PERTE EXPIRATION',
  colRealProfit: 'BÉNÉFICE RÉEL',
  colStatus: 'STATUT',
  colPerformance: 'PERFORMANCE',
  badgeHighPerformer: 'Performant',
  badgeAttention: 'Attention',
  badgeNormal: 'Normal',
  perfExcellent: 'Excellent',
  perfWeak: 'Faible',
  perfAverage: 'Moyen',
  emptyTitle: 'Aucune donnée disponible',
  emptyDesc: 'Aucune donnée de vente ou d\'achat pour la période sélectionnée',
  emptyHint: 'Essayez de modifier les filtres pour afficher plus de données',
  notAvailable: 'N/D',
  reportTitle: 'Rapport Achat vs Vente',
  exportPerformanceHigh: 'Élevée',
  exportPerformanceAttention: 'Attention',
  exportPerformanceNormal: 'Normale',
  summaryTotalProducts: 'Total produits',
  summaryAverageMargin: 'Marge moyenne (%)',
  summaryRealMargin: 'Marge réelle (%)',
  summaryGrossProfit: 'Bénéfice Brut',
  summaryRealProfit: 'Bénéfice Réel',
  export: {
    product: 'Produit',
    itemsSold: 'Articles Vendus',
    revenue: 'Revenu',
    cost: 'Coût',
    grossProfit: 'Bénéfice Brut',
    margin: 'Marge %',
    expiredProducts: 'Produits Expirés',
    expirationLoss: 'Perte Expiration',
    realProfit: 'Bénéfice Réel',
    status: 'Statut',
    performance: 'Performance'
  }
};

export const achatVsVenteReportAr = {
  unavailableTitle: 'التقرير غير متاح بعد',
  unavailableDesc: 'يجب إجراء عمليات بيع أولاً قبل إمكانية عرض تقرير الشراء مقابل البيع. هذا التقرير يحلل الأرباح والتكاليف بناءً على البيانات الفعلية للبيع.',
  stepsTitle: 'خطوات مطلوبة:',
  step1: 'إضافة منتجات إلى المخزون',
  step2: 'شراء المنتجات (إضافة إلى المخزون)',
  step3: 'إجراء عمليات بيع',
  step4: 'عرض تقرير الشراء مقابل البيع',
  title: 'تقرير الشراء مقابل البيع',
  subtitle: 'تحليل شامل للأرباح والتكاليف',
  subtitleBasis: 'فترات تقويمية ثابتة — حساب عبر التجميع اليومي',
  computing: 'جاري الحساب…',
  periodToday: 'اليوم',
  periodWeek: 'هذا الأسبوع',
  periodMonth: 'هذا الشهر',
  periodYear: 'هذه السنة',
  period28Days: '28 يوماً',
  period3Months: '3 أشهر',
  periodCurrentMonth: 'الشهر الجاري',
  period3CalendarMonths: '3 أشهر تقويمية',
  basisLabel: 'أساس الحساب:',
  basis28And3: '28 يوماً · 3 أشهر',
  basisCalendar: 'الشهر الجاري · 3 أشهر تقويمية',
  linkStockReport: 'عرض حركة المخزون',
  comparisonTitle: 'ملخص مقارن',
  comparisonDesc: 'المؤشرات المجمعة لفترتي التقويم الثابتتين',
  colMetric: 'المؤشر',
  allCategories: 'جميع الفئات',
  allMargins: 'جميع الهوامش',
  marginHigh: 'هامش عالي (≥20%)',
  marginLow: 'هامش منخفض (<20%)',
  marginNegative: 'هامش سلبي',
  allPerformance: 'جميع الأداء',
  performanceHigh: 'أداء عالي',
  performanceNormal: 'أداء عادي',
  performanceAttention: 'يحتاج انتباه',
  sortByProfit: 'ترتيب حسب الربح',
  sortByRevenue: 'ترتيب حسب الإيرادات',
  sortByMargin: 'ترتيب حسب الهامش',
  sortByName: 'ترتيب حسب الاسم',
  sortDesc: 'ترتيب تنازلي',
  sortAsc: 'ترتيب تصاعدي',
  hideCharts: 'إخفاء الرسوم',
  showCharts: 'إظهار الرسوم',
  lastUpdate: 'آخر تحديث:',
  totalProductsLabel: 'إجمالي المنتجات:',
  periodLabel: 'الفترة:',
  kpiTotalRevenue: 'إجمالي الإيرادات',
  kpiTotalRevenueDesc: 'من جميع المبيعات',
  kpiTotalProfit: 'إجمالي الربح',
  kpiTotalProfitDesc: 'الربح الصافي',
  kpiAverageMargin: 'متوسط الهامش',
  kpiAverageMarginDesc: 'نسبة الربح',
  kpiRealProfit: 'الربح الحقيقي',
  kpiRealProfitDesc: 'بعد خسائر الانتهاء',
  kpiExpiredLoss: 'خسائر الانتهاء',
  expiredProductsUnit: 'منتج منتهي',
  kpiHighPerformers: 'منتجات عالية الأداء',
  kpiHighPerformersDesc: 'تحتاج انتباه',
  kpiBestProduct: 'أفضل منتج',
  kpiProfitMargin: 'هامش الربح الإجمالي',
  kpiProfitMarginDesc: 'نسبة الربح من الإيرادات',
  chartRevenueVsCost: 'الإيرادات مقابل التكاليف',
  chartRevenue: 'إيرادات',
  chartCost: 'تكلفة',
  chartProfitDistribution: 'توزيع الأرباح',
  chartPerformanceOverview: 'نظرة عامة على الأداء',
  chartHighPerformers: 'منتجات عالية الأداء',
  chartNeedsAttention: 'يحتاج انتباه',
  chartTotalProducts: 'إجمالي المنتجات',
  tableTitle: 'التفصيل حسب المنتج',
  tableDesc: 'مقارنة الإيرادات والتكاليف والأرباح',
  tableDescPeriod: 'الصفوف المفلترة للفترة: {{period}}',
  detailMeta: '{{count}} منتج — {{period}}',
  colProduct: 'المنتج',
  colItemsSold: 'المنتجات المباعة',
  colRevenue: 'الإيرادات',
  colCost: 'التكلفة',
  colGrossProfit: 'الربح الإجمالي',
  colMargin: 'الهامش %',
  colExpiredProducts: 'المنتجات المنتهية',
  colExpirationLoss: 'خسارة انتهاء الصلاحية',
  colRealProfit: 'الربح الحقيقي',
  colStatus: 'الحالة',
  colPerformance: 'الأداء',
  badgeHighPerformer: 'عالي الأداء',
  badgeAttention: 'يحتاج انتباه',
  badgeNormal: 'عادي',
  perfExcellent: 'ممتاز',
  perfWeak: 'ضعيف',
  perfAverage: 'متوسط',
  emptyTitle: 'لا توجد بيانات متاحة',
  emptyDesc: 'لا توجد بيانات مبيعات أو مشتريات للفترة المحددة',
  emptyHint: 'جرب تغيير المرشحات لإظهار المزيد من البيانات',
  notAvailable: 'غير متوفر',
  reportTitle: 'تقرير الشراء مقابل البيع',
  exportPerformanceHigh: 'عالية',
  exportPerformanceAttention: 'انتباه',
  exportPerformanceNormal: 'عادية',
  summaryTotalProducts: 'إجمالي المنتجات',
  summaryAverageMargin: 'متوسط الهامش (%)',
  summaryRealMargin: 'الهامش الحقيقي (%)',
  summaryGrossProfit: 'الربح الإجمالي',
  summaryRealProfit: 'الربح الحقيقي',
  export: {
    product: 'المنتج',
    itemsSold: 'المنتجات المباعة',
    revenue: 'الإيرادات',
    cost: 'التكلفة',
    grossProfit: 'الربح الإجمالي',
    margin: 'الهامش %',
    expiredProducts: 'المنتجات المنتهية',
    expirationLoss: 'خسارة الانتهاء',
    realProfit: 'الربح الحقيقي',
    status: 'الحالة',
    performance: 'الأداء'
  }
};
